import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) {
    return '$0';
  }
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const StockInvestmentYearlyTable = ({ yearlyData }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-sm font-semibold border">Year</th>
            <th className="px-4 py-2 text-sm font-semibold border">Stock Value</th>
          </tr>
        </thead>
        <tbody>
          {yearlyData.map((year) => (
            <tr key={year.year} className="text-center text-xs border-t">
              <td className="px-4 py-2">{year.year}</td>
              <td className="px-4 py-2">{formatCurrency(year.stockValue)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StockInvestmentYearlyTable;
